import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import { TokenKeysEnum } from 'src/app/global/enums/token-keys.enum';
import { LocalStorageServiceVM } from '../../../services/localstorage.service';

@Injectable()
export class LocalStorageProviderVM extends LocalStorageServiceVM {
  private _secureDataKey = 'SECURE_SESSION_DATA';
  private _dataKey = 'SESSION_DATA';

  constructor() {
    super();
  }

  private getTokenKey(){
    return localStorage.getItem(TokenKeysEnum.TOKEN);
  }

  private _encrypt(toEncrypt: any): string {
    const aux: string = JSON.stringify(toEncrypt);
    const encrypted = CryptoJS.AES.encrypt(aux, this.getTokenKey()).toString();
    return encrypted;
  }

  private _decrypt(toDecrypt: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(toDecrypt, this.getTokenKey());
      const decrypted: string = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (error) {
      return null;
    }
  }

  public setData(key: string, data: any, encrypted: boolean = true): void {
    const localStorageKey = encrypted ? this._secureDataKey : this._dataKey;
    const rawData = localStorage.getItem(localStorageKey);
    let localData: Record<string, any> = {};
  
    try {
      if (rawData) {
        localData = encrypted ? this._decrypt(rawData) || {} : JSON.parse(rawData);
      }
    } catch (error) {
      console.warn(`Error parsing data from localStorage key [${localStorageKey}]:`, error);
      localData = {};
    }
  
    localData[key] = data;
  
    console.log(`LocalStorage - Set Data [${key}]:`, data);
  
    const finalData = encrypted ? this._encrypt(localData) : JSON.stringify(localData);
    localStorage.setItem(localStorageKey, finalData);
  }

  public addData(key: string, data: any, encrypted: boolean = true) {
    const localStorageKey = encrypted ? this._secureDataKey : this._dataKey;
    const rawData = localStorage.getItem(localStorageKey);
    let localData: Record<string, any> = {};
    let oldData = {};

    try {
      if (rawData) {
        localData = encrypted ? this._decrypt(rawData) || {} : JSON.parse(rawData);
      }
    } catch (error) {
      console.warn(`Error parsing data from localStorage key [${localStorageKey}]:`, error);
      localData = {};
    }

    if (localData[key] != undefined) {
      oldData = localData[key];
      data = { ...oldData, ...data };
    }

    localData[key] = data;
  
    console.log(`LocalStorage - Set Data [${key}]:`, data);
  
    const finalData = encrypted ? this._encrypt(localData) : JSON.stringify(localData);
    localStorage.setItem(localStorageKey, finalData);
  }

  public getData(key: string, encrypted: boolean = true) {
    const localStorageKey = encrypted ? this._secureDataKey : this._dataKey;
    const rawData = localStorage.getItem(localStorageKey);

    //const localDataEncrypted: string = localStorage.getItem(this._secureDataKey);
    let data: any = null;
    if (rawData) {
      const localData: any = encrypted ? this._decrypt(rawData) : JSON.parse(rawData);
      data = _.get(localData, key, {});
    }
    return data;
  }

  public clearData() {
    localStorage.clear();
  }
}
